export const BASE_URL = 'https://daki-ecommerce.herokuapp.com/api/v1'
//export const BASE_URL = 'http://localhost:3001/api/v1'
